import { CartFieldsFragment } from 'types/graphql'
import { assertExists } from 'utils/assert'

export const mapCartSkusToCartSkuUpdateInput = (cart: CartFieldsFragment) => {
  return cart.bags.flatMap((bag) =>
    bag.skus.map((sku) => {
      assertExists(sku.productVariant)
      return { productVariantId: sku.productVariant.id, quantity: sku.quantity }
    })
  )
}
